import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';

import { IngredienteService } from '../../services/ingrediente.service';
import { CombosService } from '../../services/combos.service';
import { PanSucursalCatalogoModel } from '../../models/ingrediente/ingrediente.model';


@Component({
  selector: 'app-ingrediente-pan-sucursal-dialog',
  templateUrl: './ingrediente-pan-sucursal-dialog.component.html',
  styleUrls: ['./ingrediente-pan-sucursal-dialog.component.css']
})
export class IngredientePanSucursalDialogComponent implements OnInit {

  panSucursalCatalogoModel: PanSucursalCatalogoModel;

  idsucursal: number;
  idrol: number;

  formulario: UntypedFormGroup;
  submitted = false;

  combosucursal: any[];
  combopan: any[];

  constructor(public dialogRef: MatDialogRef<IngredientePanSucursalDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private ingredienteservice: IngredienteService,
              private combosservicio: CombosService,
              private formBuilder: UntypedFormBuilder) { }

  ngOnInit(): void {

    this.formulario = this.formBuilder.group({
      idpan: ['', Validators.required],
      idsucursal: ['', Validators.required],
      estaactivo: ['']
    }, {
    });

    this.idsucursal = Number(sessionStorage.getItem('ids'));
    this.idrol = Number(sessionStorage.getItem('idr'));

    this.panSucursalCatalogoModel = new PanSucursalCatalogoModel();
    // var input = document.getElementById('idtienda');
    // input.disabled = false;

   // this.catpresentacionesmodel.idtienda = 0;
   // this.idrol = 1;
   // this.idsucursal = 0;
    this.getComboSucursal();
    this.getComboPan();

    if (this.data.row.idpanes_sucursales > 0) {
      this.panSucursalCatalogoModel = this.data.row;
    //  this.catpresentacionesmodel.personas = this.data.row.personas;
    }

    // if (this.catpresentacionesmodel.idpresentacion === 0) {
    //   this.catpresentacionesmodel.idtienda = 0;
    // }
    // this.extrasmodel.idsucursal = Number(sessionStorage.getItem('ids'));

    this.panSucursalCatalogoModel.idusuario = Number(sessionStorage.getItem('idu'));
    if (this.panSucursalCatalogoModel.estaactivo) {
        this.panSucursalCatalogoModel.estaactivo = true;
    } else {
        this.panSucursalCatalogoModel.estaactivo = false;
    }

  }

  // variable para acceder a los campos del formulario
  get f() { return this.formulario.controls; }

  get idsucursalNoValido() {
    return this.formulario.get('idsucursal').invalid;
  }

  get idpanNoValido() {
    return this.formulario.get('idpan').invalid;
  }

  abcPanSucursal() {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Guardando registro ...'
    });
    Swal.showLoading();
    this.panSucursalCatalogoModel.operacion = this.panSucursalCatalogoModel.idpanes_sucursales > 0 ? 2 : 1;
    this.panSucursalCatalogoModel.idusuario = Number(sessionStorage.getItem('idu'));

    // console.log(this.extrasmodel);
    // if (Number(sessionStorage.getItem('idr')) > 1 ) {
    //   this.panSucursalCatalogoModel.idtienda = 0;
    // }

    this.ingredienteservice.abcCatPanesSucursal(this.panSucursalCatalogoModel).subscribe( (resp: any[]) => {
        Swal.close();
        if (this.panSucursalCatalogoModel.operacion === 1) {
          this.panSucursalCatalogoModel.idpanes_sucursales = resp['idrespuesta'] !== -1 || resp['idrespuesta'] !== -2 ? resp['idrespuesta'] : 0 ;
          this.panSucursalCatalogoModel.operacion = this.panSucursalCatalogoModel.operacion === 1 ? 2 : 2;
        }
        if (resp) {
          if (resp['idrespuesta'] > 0) {
            Swal.fire({
              icon: 'success',
              text: resp['respuesta']
            });
           } else {
            Swal.fire({
              icon: 'error',
              text: resp['respuesta']
            });
           }
        }
        }, (err) => {
         switch (err.status) {
          case 0:
              Swal.fire({
                icon: 'warning',
                text: 'No hay conexión con el servidor'
              });
              break;
           case 409:
             Swal.fire({
              icon: 'error',
              text: 'Error ' + err.status + ' en el guardado la sucursal del pan'
             });
             break;
            case 500:
                Swal.fire({
                  icon: 'error',
                  text: 'Error ' + err.status + ' en el guardado la sucursal del pan'
                });
                break;
          }
        });
  }

  getComboSucursal() {
    this.combosservicio.getComboPanelSucursal(this.idsucursal, this.idrol).subscribe( (resp: any[]) => {
        this.combosucursal = resp;
        console.log(this.combosucursal);
    }, (err) => {
     switch (err.status) {
      case 0:
          Swal.fire({
            icon: 'warning',
            text: 'No hay conexión con el servidor'
          });
          break;
       case 409:
         Swal.fire({
          icon: 'error',
          text: 'Error en sucursal ' + err.status + ' en el servidor'
         });
         break;
        case 500:
            Swal.fire({
              icon: 'error',
              text: 'Error en sucursal ' + err.status + ' en el servidor'
            });
            break;
      }
    });
  }

  getComboPan() {
    this.combosservicio.getComboPanes().subscribe( (resp: any[]) => {
        this.combopan = resp;
        console.log(this.combopan);
    }, (err) => {
     switch (err.status) {
      case 0:
          Swal.fire({
            icon: 'warning',
            text: 'No hay conexión con el servidor'
          });
          break;
       case 409:
         Swal.fire({
          icon: 'error',
          text: 'Error en sucursal ' + err.status + ' en el servidor'
         });
         break;
        case 500:
            Swal.fire({
              icon: 'error',
              text: 'Error en sucursal ' + err.status + ' en el servidor'
            });
            break;
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit() {

    this.submitted = true;

   // se detiene si el formulario es invalido
    if (this.formulario.invalid) {
        return;
    }
    this.abcPanSucursal();

    // valores visibles del formmulario
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value, null, 4));
    // valores del modelo que se pasa al abc
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.extrasmodel, null, 4));

  }

}
